<script>
export default {
  props: {
    size: {
      type: String,
      default: '18',
    },
  },
}
</script>
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.19735 17.0625C7.83735 17.0625 7.47735 16.9725 7.15485 16.7925C6.48735 16.4175 6.08985 15.7425 6.08985 14.985V10.9725C6.08985 10.5975 5.84235 10.0275 5.60235 9.73499L2.75235 6.74249C2.27985 6.25499 1.91235 5.43751 1.91235 4.83751V3.09C1.91235 1.8825 2.82735 0.9375 3.98985 0.9375H13.9949C15.1424 0.9375 16.0724 1.86751 16.0724 3.01501V4.67999C16.0724 5.46749 15.6074 6.35252 15.1574 6.81752L13.8074 8.00999C13.6724 8.12999 13.4849 8.17498 13.3049 8.13748C13.1024 8.08498 12.8849 8.0625 12.6599 8.0625C11.0024 8.0625 9.65985 9.405 9.65985 11.0625C9.65985 11.61 9.80985 12.1425 10.0949 12.6075C10.3349 13.005 10.6574 13.335 11.0324 13.5675C11.1974 13.6725 11.3024 13.8525 11.3024 14.0475V14.3025C11.3024 14.895 10.9424 15.7275 10.3424 16.08L9.30735 16.7475C8.96985 16.9575 8.57985 17.0625 8.19735 17.0625ZM3.99736 2.0625C3.46486 2.0625 3.04485 2.5125 3.04485 3.09V4.83751C3.04485 5.10751 3.26985 5.66251 3.56985 5.96251L6.45735 9C6.83985 9.4725 7.22235 10.275 7.22235 10.98V14.9925C7.22235 15.4875 7.56735 15.735 7.70985 15.8175C8.03235 15.9975 8.41485 15.99 8.70735 15.81L9.75735 15.135C9.95985 15.015 10.1624 14.6325 10.1774 14.3625C9.76485 14.055 9.40485 13.6575 9.13485 13.2075C8.74485 12.57 8.53485 11.835 8.53485 11.085C8.53485 8.81252 10.3874 6.96002 12.6599 6.96002C12.8699 6.96002 13.0799 6.97502 13.2749 7.00502L14.3849 6.02252C14.6399 5.76002 14.9549 5.13751 14.9549 4.69501V3.02998C14.9549 2.50498 14.5274 2.07751 14.0024 2.07751H3.99736V2.0625Z"
      fill="#1C1C1C"
    />
    <path
      d="M4.5 8.06245C4.395 8.06245 4.2975 8.03245 4.2 7.97995C3.9375 7.81495 3.855 7.46245 4.02 7.19995L7.7175 1.27495C7.8825 1.01245 8.2275 0.929953 8.49 1.09495C8.7525 1.25995 8.835 1.60495 8.67 1.86745L4.9725 7.79245C4.8675 7.96495 4.6875 8.06245 4.5 8.06245Z"
      fill="#1C1C1C"
    />
    <path
      d="M12.6599 15.1875C11.2199 15.1875 9.86241 14.4225 9.12741 13.185C8.73741 12.555 8.53491 11.82 8.53491 11.0625C8.53491 8.79 10.3874 6.9375 12.6599 6.9375C14.9324 6.9375 16.7849 8.79 16.7849 11.0625C16.7849 11.82 16.5749 12.555 16.1849 13.1925C15.4574 14.4225 14.1074 15.1875 12.6599 15.1875ZM12.6599 8.0625C11.0024 8.0625 9.65991 9.405 9.65991 11.0625C9.65991 11.61 9.80991 12.1425 10.0949 12.6C10.6349 13.5075 11.6174 14.0625 12.6599 14.0625C13.7249 14.0625 14.6849 13.5225 15.2249 12.6075C15.5099 12.1425 15.6599 11.61 15.6599 11.0625C15.6599 9.405 14.3174 8.0625 12.6599 8.0625Z"
      fill="#EF8C13"
    />
    <path
      d="M13.995 11.61H11.3325C11.025 11.61 10.77 11.355 10.77 11.0475C10.77 10.74 11.025 10.485 11.3325 10.485H13.995C14.3025 10.485 14.5575 10.74 14.5575 11.0475C14.5575 11.355 14.3025 11.61 13.995 11.61Z"
      fill="#EF8C13"
    />
    <path
      d="M12.6599 12.9675C12.3524 12.9675 12.0974 12.7125 12.0974 12.405V9.75C12.0974 9.4425 12.3524 9.1875 12.6599 9.1875C12.9674 9.1875 13.2224 9.4425 13.2224 9.75V12.4125C13.2224 12.72 12.9749 12.9675 12.6599 12.9675Z"
      fill="#EF8C13"
    />
  </svg>
</template>
